// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__9nrFF","search":"Settings_search__3LXH8","filter":"Settings_filter__KliVv"};